import { ReactNode } from 'react';
import { useHighlightedMappingsMap, useIsActive } from '../../../../../../stores/mappingStore';
import { RowIdType } from '../../../../../../types';
import { getImportDescriptorStyling } from './utils';

type ImportDescriptorCellPropsType = {
    children: ReactNode;
    confidence: number;
    rowId: RowIdType;
};

function ImportDescriptorCell({ children, confidence, rowId }: ImportDescriptorCellPropsType) {
    const isDragging = useIsActive(rowId);
    const highlightedMappingsMap = useHighlightedMappingsMap();

    const { styles, classes } = getImportDescriptorStyling(confidence, highlightedMappingsMap, rowId, isDragging);

    return (
        <td style={styles} className={classes}>
            {children}
        </td>
    );
}

export default ImportDescriptorCell;
